import React, { useRef, useEffect, useState } from 'react';
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
  MDBBtn,
  MDBIcon,
  MDBTable,
  MDBTableHead,
  MDBTableBody,
} from 'mdb-react-ui-kit';
import Dashboardicon from '../assets/images/Dashboardicon.png';
import baricon from '../assets/images/baricon.png';
import proficon from '../assets/images/proficon.png';
import revenueicon from '../assets/images/revenueicon.png';

import PieChart from './PieChart';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useLocation } from 'react-router-dom';
import filterAndReduceVoucherAmountByMonthlyAndVoucherType from '../utilities/filterAndReduceVoucherAmountByMonthlyAndVoucherType';
import getMonthNameWithYear from '../utilities/getMonthNameWithYear';
import DataTable from './DataTable';



const TotalRevenue = () => {

  const [selectedDate, setSelectedDate] = useState(null);
  const location = useLocation();
  const { monthData, monthIndex } = location.state;

  console.log(monthData, monthIndex);

  // Get the current date
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear()

  const { reducedAmount, filteredVouchers } = monthData;


  console.log(monthData);

  const voucherNames = [
    "Coupon",
    "Memo",
    "Vakalatnama",
    "Sale deed/Gift deed",
    "Marriage Coupon",
    "Will/Attorney/Lease /Agreement",
    "Challan Coupon"
  ];

  const MonthlySalesVoucherCounts = [];

  for (let voucherName of voucherNames) {
    const countByVoucherType = filterAndReduceVoucherAmountByMonthlyAndVoucherType(filteredVouchers, monthIndex, currentYear, voucherName).count;
    console.log(countByVoucherType);
    MonthlySalesVoucherCounts.push(countByVoucherType);
  }

  console.log(MonthlySalesVoucherCounts);

  const soldVoucherTableColumns = [
    { field: 'id', headerName: 'ID', minWidth: 130, flex: 1, align: 'left', headerAlign: 'left' },
    { field: 'voucherType', headerName: 'Voucher Type', type: 'text', minWidth: 130, flex: 1, align: 'left', headerAlign: 'left' },
    { field: 'voucherBookNo', headerName: 'Book No', minWidth: 130, flex: 1, align: 'left', headerAlign: 'left' },
    { field: 'voucherSrNo', headerName: 'Sr No', type: 'number', minWidth: 90, flex: 1, align: 'left', headerAlign: 'left' },
    { field: 'voucherAmount', headerName: 'Amount', type: 'number', minWidth: 90, flex: 1, align: 'left', headerAlign: 'left' },
    { field: 'purchaserType', headerName: 'Purchaser Type', minWidth: 130, flex: 1, align: 'left', headerAlign: 'left' },
    { field: 'uttrakhandBarId', headerName: 'Purchaser ID', minWidth: 130, flex: 1, align: 'left', headerAlign: 'left' },
    { field: 'voucherPurchaseDate', headerName: 'Purchase Date', minWidth: 160, flex: 1, align: 'left', headerAlign: 'left' },
  ];

  return (
    <>
      <MDBContainer fluid>

        <MDBRow className="my-3 justify-content-center">
          <MDBCol xl="8" className="d-flex align-items-center">
            <a href='/Dashboard'>
              <img src={Dashboardicon} alt="Dashboard Icon" className="me-2" style={{ width: '48px' }} />

            </a>
            <h4 className="m-0" >Total Revenue</h4>
          </MDBCol>
        </MDBRow>


        <MDBRow className='justify-content-center mt-4'>
          <MDBCol xl="4">
            <MDBCol className="mb-4">
              <MDBCard className="h-100">
                <MDBCardBody className="d-flex flex-column">
                  <MDBCol className="flex-grow-1 mx-2 p-1">
                    <MDBRow className="align-items-center">

                      <MDBCol>
                        <MDBCardText className='text-bold'>
                          <h1>₹ {reducedAmount}</h1>
                          <p className="text-small">Total Revenue</p>
                        </MDBCardText>
                      </MDBCol>
                      <MDBCol size="auto">
                        <img src={revenueicon} alt="Check Circle Icon" className="me-2" style={{ width: '48px' }} />
                      </MDBCol>
                    </MDBRow>
                  </MDBCol>
                </MDBCardBody>
              </MDBCard>
            </MDBCol>

            <MDBCol className="mb-4">
              <MDBCard className="h-100">
                <MDBCardBody className="d-flex flex-column">
                  <MDBRow className="d-flex justify-content-between mb-3">
                    <MDBCol xl="8" className="d-flex flex-column align-items-start">
                      <MDBCardTitle style={{ fontWeight: 'bold' }}>Sections Graph</MDBCardTitle>
                      <MDBCardText className="text-small">
                        Revenue Generated Sections Wise
                      </MDBCardText>
                    </MDBCol>
                  </MDBRow>
                  <MDBRow className="d-flex justify-content-center flex-grow-1">
                    <MDBCol md="12" className="d-flex flex-column align-items-center mt-1">
                      {MonthlySalesVoucherCounts.length > 0 &&
                        <PieChart voucherCounts={MonthlySalesVoucherCounts} />}
                    </MDBCol>
                  </MDBRow>
                </MDBCardBody>
              </MDBCard>
            </MDBCol>

          </MDBCol>
          <MDBCol xl="4" className="mb-4">
            <MDBCard className="">
              <MDBCardBody className="d-flex flex-column">
                <MDBRow className="d-flex justify-content-between mb-3">
                  <MDBCol md="6" className="d-flex flex-column align-items-start">
                    <MDBCardTitle style={{ fontWeight: 'bold' }}>
                      Sections List
                    </MDBCardTitle>
                    <MDBCardText className="text-small">
                      List of Revenue Generated in all Sections
                    </MDBCardText>
                  </MDBCol>
                  <MDBCol md="6" className="d-flex flex-column align-items-end">
                    <MDBCardText>
                      <h5 className="text-small text-end">{getMonthNameWithYear(monthIndex)}</h5>
                    </MDBCardText>
                  </MDBCol>
                </MDBRow>
                <MDBRow className="d-flex justify-content-center flex-grow-1">
                  <div style={{ width: '100%', height: 'auto' }}>
                    <MDBTable className="custom-table">
                      <MDBTableHead>
                        <tr>
                          <th>Document Name</th>
                          <th>Quantity</th>
                          <th>Revenue</th>
                        </tr>
                      </MDBTableHead>
                      <MDBTableBody>
                        <tr>
                          <td>Coupon</td>
                          <td>{filterAndReduceVoucherAmountByMonthlyAndVoucherType(filteredVouchers, monthIndex, currentYear, 'Coupon').count}</td>
                          <td>₹ {filterAndReduceVoucherAmountByMonthlyAndVoucherType(filteredVouchers, monthIndex, currentYear, 'Coupon').reducedAmount}</td>
                        </tr>
                        <tr>
                          <td>Memo</td>
                          <td>{filterAndReduceVoucherAmountByMonthlyAndVoucherType(filteredVouchers, monthIndex, currentYear, 'Memo').count}</td>
                          <td>₹ {filterAndReduceVoucherAmountByMonthlyAndVoucherType(filteredVouchers, monthIndex, currentYear, 'Memo').reducedAmount}</td>
                        </tr>
                        <tr>
                          <td>Vakalatnama</td>
                          <td>{filterAndReduceVoucherAmountByMonthlyAndVoucherType(filteredVouchers, monthIndex, currentYear, 'Vakalatnama').count}</td>
                          <td>₹ {filterAndReduceVoucherAmountByMonthlyAndVoucherType(filteredVouchers, monthIndex, currentYear, 'Vakalatnama').reducedAmount}</td>
                        </tr>
                        <tr>
                          <td>Sale Deed/ Gift Deed</td>
                          <td>{filterAndReduceVoucherAmountByMonthlyAndVoucherType(filteredVouchers, monthIndex, currentYear, 'Sale deed/Gift deed').count}</td>
                          <td>₹ {filterAndReduceVoucherAmountByMonthlyAndVoucherType(filteredVouchers, monthIndex, currentYear, 'Sale deed/Gift deed').reducedAmount}</td>
                        </tr>
                        <tr>
                          <td>Marriage Coupon</td>
                          <td>{filterAndReduceVoucherAmountByMonthlyAndVoucherType(filteredVouchers, monthIndex, currentYear, 'Marriage Coupon').count}</td>
                          <td>₹ {filterAndReduceVoucherAmountByMonthlyAndVoucherType(filteredVouchers, monthIndex, currentYear, 'Marriage Coupon').reducedAmount}</td>
                        </tr>
                        <tr>
                          <td>Will/Attorney/Lease/Agreement</td>
                          <td>{filterAndReduceVoucherAmountByMonthlyAndVoucherType(filteredVouchers, monthIndex, currentYear, 'Will/Attorney/Lease /Agreement').count}</td>
                          <td>₹ {filterAndReduceVoucherAmountByMonthlyAndVoucherType(filteredVouchers, monthIndex, currentYear, 'Will/Attorney/Lease /Agreement').reducedAmount}</td>
                        </tr>
                        <tr>
                          <td>Challan Coupon</td>
                          <td>{filterAndReduceVoucherAmountByMonthlyAndVoucherType(filteredVouchers, monthIndex, currentYear, 'Challan Coupon').count}</td>
                          <td>₹ {filterAndReduceVoucherAmountByMonthlyAndVoucherType(filteredVouchers, monthIndex, currentYear, 'Challan Coupon').reducedAmount}</td>
                        </tr>
                      </MDBTableBody>
                    </MDBTable>
                  </div>
                </MDBRow>
              </MDBCardBody>
            </MDBCard>
          </MDBCol>


        </MDBRow>
      </MDBContainer>
    </>
  )
}

export default TotalRevenue
